import styled, { css } from 'styled-components';
type Value = 'None' | 'Low' | 'Good';

const color = (value: Value, alpha: number) => {
  if (value === 'None') {
    return css`
      ${({ theme }) => theme.color.lightGrayRGBA(alpha)}
    `;
  }
  if (value === 'Low') {
    return css`
      ${({ theme }) => theme.color.warningRGBA(alpha)}
    `;
  }
  return css`
    ${({ theme }) => theme.color.goodRGBA(alpha)}
  `;
};

export const Mark = styled('mark')<{ value: Value }>`
  padding: 2px 6px;
  background-color: transparent;
  color: ${({ value }) => color(value, 1)};
  border: 1px solid ${({ value }) => color(value, 0.2)};
  border-radius: 4px;
`;
